<template>
    <div>
        <monitoramento-component></monitoramento-component>
    </div>
</template>
<script>
import MonitoramentoComponent from '../../components/Painel/MonitoramentoComponent.vue';

export default {
    components: {
        MonitoramentoComponent
    }
}
</script>

